export default "__VITE_ASSET__C6xX26TU__"